import { render, staticRenderFns } from "./ShortCodesAdd.vue?vue&type=template&id=1efaf6b7"
import script from "./ShortCodesAdd.vue?vue&type=script&lang=js"
export * from "./ShortCodesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports